export default [
  {
    filing_status: 'submitted',
    review_status: 'approved',
    buttons: ['print', 'downloadCertificate', 'downloadPDF'],
    comments_visible: false,
    can_comment: false,
    edit: 'not_allowed',
    schedule: 'none',
  },
  {
    filing_status: 'submitted',
    review_status: 'declined',
    buttons: ['print'],
    comments_visible: false,
    can_comment: false,
    edit: 'not_allowed',
    schedule: 'none',
  },
  {
    filing_status: 'submitted',
    review_status: 'waiting_for_voting',
    is_sign: true,
    buttons: {
      buttonsBeforeVoting: ['vote', 'print'],
      buttonsDuringVoting: ['preliminaryResults', 'vote', 'print'],
      buttonsAfterVoting: ['preliminaryResults', 'print'],
    },
    comments_visible: true,
    can_comment: true,
    edit: 'not_allowed',
    schedule: 'view',
  },
];
